import { LocationMovementsModel } from '../../models/LocationMovements';
import { MovementOrderCell, MovementTaskCell } from './MovementReference';

export function renderMovementOrder(data: LocationMovementsModel): JSX.Element {
  return <MovementOrderCell item={data} />;
}

export function renderMovementTask(data: LocationMovementsModel): JSX.Element {
  return <MovementTaskCell item={data} />;
}

/** Vista móvil: pedido, tarea y descripción */
export function renderMovementReferences(data: LocationMovementsModel): JSX.Element {
  const description = data.description?.trim();

  return (
    <div className="flex flex-col gap-1 min-w-0">
      <MovementOrderCell item={data} />
      <MovementTaskCell item={data} />
      {description ? <span className="text-xs text-title line-clamp-2">{description}</span> : null}
    </div>
  );
}
